<template>
  <vs-row>
    <vs-col class="p-1" vs-lg="6" vs-sm="6" vs-xs="12">
      <div>
        <div
          class="grid place-content-center h-full"
          v-if="!themeBookingTags || themeBookingTags.length === 0"
        >
          <p class="text-gray text-sm">
            No available tags
          </p>
        </div>
        <vs-select
          v-if="themeBookingTags && themeBookingTags.length > 0"
          label="Booking tag"
          class="w-full"
          v-model="selectedTag"
          placeholder="Select theme tag"
          :disabled="disableComponent"
        >
          <vs-select-item
            v-for="tagWithTranslation in themeBookingTags"
            :key="tagWithTranslation.tag"
            :value="tagWithTranslation.tag"
            :text="
              tagWithTranslation.getTranslation()
            "
          />
        </vs-select>
      </div>
    </vs-col>

    <vs-col class="p-1" vs-lg="6" vs-sm="6" vs-xs="12" v-if="showOtherTag">
      <div>
        <vs-input
          label="Other tag"
          class="w-full"
          v-model="otherTag"
          :disabled="disableComponent"
        />
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import * as _ from "lodash";
import { Booking } from "@/store/modules/marcom/data-model/bookings";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    booking: Object,
    section: Object,
    disableComponent: Boolean
  },
  model: {
    prop: "booking",
    event: "booking-tag-updated",
  },
  data() {
    return {
      otherTagName: "",
      commonTag: undefined,
      THEME_OTHER: "THEME:OTHER"
    };
  },
  async mounted() {
    this.selectedTag = this.booking.getThemeTag();
  },
  watch: {
    booking(newBooking, oldBooking) {
      if (newBooking) this.selectedTag = newBooking.getThemeTag();
      else this.selectedTag = undefined;
    },
  },
  computed: {
    ...mapGetters({
      themeBookingTags: "marcom/themeBookingTags",
    }),
    showOtherTag() {
      return (
        this.themeBookingTags &&
        this.themeBookingTags.length > 0 &&
        _.startsWith(_.toUpper(this.commonTag), this.THEME_OTHER)
      );
    },
    selectedTag: {
      get() {
        return this.commonTag;
      },
      set(newTag) {
        const index = _.findIndex(
          this.themeBookingTags,
          (twt) => twt.tag === newTag
        );
        if (index >= 0 && newTag !== this.THEME_OTHER) {
          this.commonTag = newTag;
          this.otherTagName = "";
          if (this.booking.getThemeTag() !== newTag) {
            this.booking.addThemeTag(newTag);
            this.$emit(
              "booking-tag-updated",
              Object.assign(new Booking(), this.booking)
            );
          }
        } else {
          this.commonTag = this.THEME_OTHER;

          if(!newTag) {
            this.otherTag = "";
          }
          else if(_.startsWith(_.toUpper(newTag), `${this.THEME_OTHER}|`)) {
            this.otherTag = newTag.substring(`${this.THEME_OTHER}|`.length);
          }
          else if (_.startsWith(_.toUpper(newTag), `${this.THEME_OTHER}`.length)) {
            this.otherTag = "";
          }
        }
      },
    },
    otherTag: {
      // getter
      get() {
        return this.otherTagName;
      },
      // setter
      set(newValue) {
        this.otherTagName = newValue;
        if (
          !!newValue &&
          !!newValue.trim() &&
          this.booking.getThemeTag() !== `${this.THEME_OTHER}|${newValue}`
        ) {
          this.booking.addThemeTag(`${this.THEME_OTHER}|${newValue}`);
          this.$emit(
            "booking-tag-updated",
            Object.assign(new Booking(), this.booking)
          );
        }
      },
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>
